<div class="home-container">
  <true-breadcrumbs [subset]="this.config.subset" [assessmentName]="assessmentName + ' (' + assessmentObject + ')'"></true-breadcrumbs>
  <div class="home-instructions">
    <p>Follow the steps to build your business model, get instant AI feedback, and submit it for expert review. Start a new assessment or continue where you left off.</p>    
  </div>
  <div class="flow-wrapper">
    <img src="assets/icons/flow-snake-shortened.svg" class="flow-overlay" />
    <div class="section-tabs">
      <!-- your 6 tab-cards -->          
      <div (click)="chooseAssessment()" class="tab-card has-border">
        <div class="tab-btn">
          <img src="assets/icons/rocket-solid.svg">
          <span>Start or Continue</span>
        </div>
        <p class="tagline">1) Begin a New Assessment or Resume a Previous One</p>
      </div>  
      <div (click)="navigate('canvas')" class="tab-card">
          <div class="tab-btn">
              <img src="assets/icons/table-solid.svg">
              <span>Lean Canvas</span>
          </div>
          
          <p class="tagline">2) Clarify Your Business Vision</p>
      </div>
      <div (click)="navigate('trl')" class="tab-card">
          <div class="tab-btn">
              <img src="assets/icons/rectangle-list-solid.svg">
              <span>Technology Readiness Level</span>
          </div>
          <p class="tagline">3) Understand Your Innovation's Development Stage</p>
      </div>
      <div (click)="navigate('brief')" class="tab-card">            
          <div class="tab-btn">
              <img src="assets/icons/file-contract-solid.svg">
              <span>Business Model</span>
          </div>
          <p class="tagline">4) Detail Your Strategic Objectives</p>
      </div>
      <div (click)="navigate('nodes')" class="tab-card">
          <div class="tab-btn">                    
              <img src="assets/icons/analysis.svg">
              <span>Sustainability</span>
          </div>
          <p class="tagline">5) Enhance Your Farm's Sustainability</p>
      </div>        
      <div (click)="navigate('insights')" class="tab-card has-border">
        <div class="tab-btn">
          <img src="assets/icons/lightbulb-solid.svg">
          <span>Insights</span>
        </div>
        <p class="tagline">6) Review AI Feedback and Submit for Expert Evaluation</p>
      </div>
    </div>
  </div>
</div>
